import isMuiElement from '@mui/utils/isMuiElement';
export default isMuiElement;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/isMuiElement.js
// module id = 164
// module chunks = 22